module.exports = __webpack_public_path__ + "img/tool-time.4d908c3.webp";